/*eslint-disable*/
import {
	Box, Typography, LinearProgress, IconButton, Paper,
	Tooltip
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const ProgressCard = (props) => {
	const { label, percent, amount, color, redirection = {}, renderCustomQty, renderOutOf = null, icon } = props;
	return (
		<Paper
			elevation={0}
			sx={{
				position: 'relative',
				borderRadius: 2,
				overflow: 'hidden',
				p: 1.5,
				flex: 1,
				bgcolor: 'grey.100',
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 1,
				minWidth: '140px',
			}}
		>
			{/* Left side - Label and Amount stacked */}
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					zIndex: 2,
					position: 'relative',
					flex: 1,
					minWidth: 0,
					overflow: 'hidden',
				}}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
					{icon && (
						<img
							src={icon}
							alt="icon"
							style={{
								width: 16,
								height: 16,
								flexShrink: 0
							}}
						/>
					)}
					<Typography
						variant="body2"
						fontWeight="600"
						sx={{
							fontSize: '12px',
							lineHeight: 1.2,
							wordBreak: 'break-word',
						}}
					>
						{label} ({percent}%)
					</Typography>
				</Box>
				<Tooltip title={`${amount} ${renderOutOf ? "/" + renderOutOf : ""}`}>
				<Typography
					variant="body2"
					fontWeight="700"
					sx={{
						fontSize: '13px',
						color: 'text.primary',
						whiteSpace: 'nowrap',
						bgcolor: 'rgba(0, 0, 0, 0.06)',
						px: 1,
						py: 0.25,
						borderRadius: 1,
					}}
					>
					{amount} {renderOutOf ? "/" + renderOutOf : ""}
				</Typography>
				</Tooltip>
				{renderCustomQty && (
					<Box
						sx={{
							fontSize: '9px',
							color: 'grey.500',
							opacity: 0.85,
						}}
					>
						{renderCustomQty}
					</Box>
				)}
			</Box>

			{/* Right side - Redirection Icon */}
			{redirection?.url && (
				<IconButton
					size="small"
					onClick={() => window.open(redirection.url, '_blank')}
					sx={{
						zIndex: 2,
						flexShrink: 0,
						bgcolor: 'rgba(255, 255, 255, 0.8)',
						'&:hover': {
							bgcolor: 'rgba(255, 255, 255, 1)',
						},
					}}
				>
					<OpenInNewIcon sx={{ fontSize: 16 }} />
				</IconButton>
			)}
			{/* Background Progress */}
			<LinearProgress
				variant="determinate"
				value={percent}
				sx={{
					height: '100%',
					borderRadius: 1,
					position: 'absolute',
					bottom: 0,
					left: 0,
					width: `${percent}%`,
					backgroundColor: color || '#facc15',
					'& .MuiLinearProgress-bar': {
						backgroundColor: color || '#facc15',
					},
				}}
			/>
		</Paper>

	);
};

export default ProgressCard;

